import { render, staticRenderFns } from "./VideoMenu.vue?vue&type=template&id=59c946d3"
import script from "./VideoMenu.vue?vue&type=script&lang=js"
export * from "./VideoMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports